import React, { useState, useEffect } from "react";

import { useHistory, useParams } from "react-router-dom";

import { BsFillArrowLeftCircleFill } from "react-icons/bs";

import { Form, Formik, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import { isAfter, parse, isValid } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";

import {
  Flex,
  HStack,
  Divider,
  Icon,
  Text,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Button,
  Grid,
  GridItem,
  Box,
} from "@chakra-ui/react";

import CustomDropzone from "../../../../components/CustomDropzone";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";

import AnexosSAService from "../../../../../main/services/AnexosSAService";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import { useAppContext } from "../../../../../Context/MessageContextProvider";

const CadastrarAnexos = () => {
  const { id, idCategoria } = useParams();
  const history = useHistory();
  const { cadastrarAnexo, setCadastrarAnexo } = useAppContext();
  const [categorias, setCategorias] = useState([]);
  const [nomeCategoria, setNomeCategoria] = useState("");
  const [initialValues] = useState({
    descricao: "",
    dataAnexo: "",
    anexo: null,
  });

  const suportedFormats = [
    ".png",
    ".bmp",
    ".tiff",
    ".jpg",
    ".jpeg",
    ".doc",
    ".docx",
    ".txt",
    ".dot",
    ".pdf",
    ".xml",
    ".xls",
    ".xlam",
    ".ods",
  ];

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);

    AnexosSAService.listarCategorias(id)
      .then((res) => {
        setCategorias(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  useEffect(() => {
    if (Number(idCategoria) >= 1 && Number(idCategoria) <= 12) {
      if (categorias) {
        categorias.forEach((categoria) => {
          if (Number(categoria[0]) === Number(idCategoria)) {
            if (
              !(
                categoria[1] === "Fotos do Serviço de Acolhimento" ||
                categoria[1] === "Outros Anexos"
              )
            ) {
              Swal.fire({
                title: "Atenção!",
                text: "Não é possível cadastrar arquivos para essa categoria nesta página!",
                icon: "warning",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              }).then(() => {
                history.push(`/servico-acolhimento/visualizar-anexos/${id}`);
              });
            }
            setNomeCategoria(categoria[1]);
          }
        });
      }
    } else {
      Swal.fire({
        title: "Atenção!",
        text: "Essa categoria é inexistente!",
        icon: "warning",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      }).then(() => {
        history.push(`/servico-acolhimento/visualizar-anexos/${id}`);
      });
    }
  }, [categorias, history, id, idCategoria]);

  const backAlert = () => {
    if (cadastrarAnexo) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          history.goBack();
          setCadastrarAnexo(false);
        }
      });
    } else {
      history.goBack();
    }
  };

  const schema = Yup.object().shape({
    descricao: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .trim("Este campo é obrigatório!"),
    dataAnexo: Yup.string("Este campo é obrigatório!")
      .nullable()
      .required("Este campo é obrigatório!")
      .test(
        "inicioServicoAfterToday",
        "A data informada não pode ser uma data futura!",
        (value) => {
          if (value === null) {
            return false;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        }
      )
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return false;
        }
      }),
    anexo: Yup.mixed()
      .required("Este campo é obrigatório!")
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
  });

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const { dataAnexo, dtAssinaturaTermo, ...resto } = values;

      const valuesToSend = {
        categoriaAnexoId: idCategoria,
        servicoAcolhimentoId: id,
        dataAnexo: parse(dataAnexo, "dd/MM/yyyy", new Date()).toISOString(),
        nomeTabela: "MCAF_ANEXOS",
        ...resto,
      };

      AnexosSAService.novaAnexoSA(valuesToSend)
        .then((res) => {
          Swal.fire({
            title: "Sucesso!",
            text: "Registro cadastrado com sucesso!",
            icon: "success",
            confirmButtonText: "Continuar",
            confirmButtonColor: "#169499",
          }).then(function () {
            history.goBack();
          });
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (error.response.data.field === "Anexos") {
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message,
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  }).then(() => {
                    history.goBack();
                  });
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    actions.setFieldError(key.toString(), errors[key]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
          actions.setSubmitting(false);
        });
    }, 200);
  };

  return categorias ? (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(props) => (
        <Form>
          {setCadastrarAnexo(hasFormChanged(initialValues, props.values))}
          <Flex
            bgColor="#FFF"
            p="20px"
            mt="15px"
            borderRadius="16px"
            flexDir="column"
          >
            <HStack>
              <Icon
                aria-label="Voltar"
                color="#169499"
                as={BsFillArrowLeftCircleFill}
                boxSize="30px"
                _hover={{ cursor: "pointer" }}
                onClick={backAlert}
              />
              <Text
                color="#95BCBF"
                fontWeight="700"
                fontSize="16px"
                lineHeight="21.6px"
              >
                {`Anexos - ${nomeCategoria} - Adicionar`.toUpperCase()}
              </Text>
            </HStack>
            <Divider orientation="horizontal" mt="10px" />
            <Grid
              mt="20px"
              templateColumns={{ base: "repeat(1, 1fr)", lg: "repeat(2, 1fr)" }}
              gap="20px"
              rowGap="15px"
            >
              <GridItem colSpan={1}>
                <Field name="descricao">
                  {({ field, form }) => (
                    <FormControl
                      isInvalid={
                        form.errors.descricao && form.touched.descricao
                      }
                      id="descricao"
                    >
                      <FormLabel
                        color="#5F6377"
                        fontWeight="500"
                        fontSize="14px"
                        lineHeight="19.6px"
                        htmlFor="descricao"
                      >
                        Descrição*
                      </FormLabel>
                      <Input
                        {...field}
                        h="42px"
                        name="descricao"
                        id="descricao"
                        backgroundColor="#fff"
                        autoComplete="off"
                        border="1px solid #D7D8DE"
                        placeholder="Descrição do Anexo"
                      />
                      <FormErrorMessage>
                        {form.errors.descricao}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              </GridItem>
              <GridItem colSpan={1}>
                <CustomDatepickerWField
                  fieldName="dataAnexo"
                  label={
                    nomeCategoria === "Fotos do Serviço de Acolhimento"
                      ? "Data da foto*"
                      : "Data do anexo*"
                  }
                  placeholder="DD/MM/AAAA"
                />
              </GridItem>
              <GridItem colSpan={{ base: 1, lg: 2 }}>
                <Box h={"72px"}>
                  <CustomDropzone
                    title="Anexar*"
                    fieldName="anexo"
                    formProps={props}
                    height="120px"
                    heightImage="80%"
                  />
                </Box>
              </GridItem>
            </Grid>
          </Flex>
          <Flex mt="30px" justifyContent="flex-end">
            <Button
              type="submit"
              translate="no"
              color="#FFF"
              backgroundColor="#169499"
              fontWeight={700}
              fontSize="15px"
              lineHeight="21.6px"
              _hover={{ bg: "#169499" }}
              w="17%"
              isLoading={props.isSubmitting}
            >
              Salvar
            </Button>
          </Flex>
        </Form>
      )}
    </Formik>
  ) : (
    <Flex w="100%" mt="25%" justifyContent="center">
      <LoadingSpinner />
    </Flex>
  );
};

export default CadastrarAnexos;
